export type ConstituentComplaintDocumentRole = "attachment" | "evidence" | "correspondence";

export const CONSTITUENT_COMPLAINT_DOCUMENT_ROLE_LABELS: Record<
  ConstituentComplaintDocumentRole,
  string
> = {
  attachment: "Attachment",
  evidence: "Evidence",
  correspondence: "Correspondence",
};

export type ConstituentComplaintDocumentLink = {
  id: number;
  constituent_complaint_id: number;
  document_id: number;
  name: string;
  file_path: string;
  label: string | null;
  role: ConstituentComplaintDocumentRole;
  linked_by_user_id: number;
  linked_by_name: string;
  created_at: string;
};

const jsonHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

function csrfToken(): string {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") ?? "";
}

function documentsPath(municipalityId: number, complaintId: number, linkId?: number): string {
  const base = `/api/v1/municipalities/${municipalityId}/trust_complaints/${complaintId}/documents`;
  return linkId != null ? `${base}/${linkId}` : base;
}

export async function listConstituentComplaintDocuments(
  municipalityId: number,
  complaintId: number,
): Promise<ConstituentComplaintDocumentLink[]> {
  const response = await fetch(documentsPath(municipalityId, complaintId), {
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  if (!response.ok) throw new Error("Failed to load documents");
  return response.json();
}

export async function linkConstituentComplaintDocument(
  municipalityId: number,
  complaintId: number,
  documentId: number,
  options?: { label?: string; role?: ConstituentComplaintDocumentRole },
): Promise<ConstituentComplaintDocumentLink> {
  const response = await fetch(documentsPath(municipalityId, complaintId), {
    method: "POST",
    credentials: "include",
    headers: { ...jsonHeaders, "X-CSRF-Token": csrfToken() },
    body: JSON.stringify({
      constituent_complaint_document: {
        document_id: documentId,
        label: options?.label,
        role: options?.role,
      },
    }),
  });
  if (!response.ok) throw new Error("Failed to link document");
  return response.json();
}

export async function unlinkConstituentComplaintDocument(
  municipalityId: number,
  complaintId: number,
  linkId: number,
): Promise<void> {
  const response = await fetch(documentsPath(municipalityId, complaintId, linkId), {
    method: "DELETE",
    credentials: "include",
    headers: { "X-CSRF-Token": csrfToken() },
  });
  if (!response.ok) throw new Error("Failed to unlink document");
}
